module.exports = "pegasus/assets/blocks/column-3-theme6.png";